var URLs = {
	homepage: 'https://awk-prototype.webflow.io/'
};

if ( window.location.pathname === "/app-main") {
	StateURL.setDefaultParam('subpage', 'dashboard', {doNotCreateHistoryState: true});
}